<template>
	<div>
		<!-- Header -->
		<b-navbar toggleable="lg" type="dark" variant="primary" class="mb-4">
			<b-navbar-brand href="#">
				<img src="@/assets/logo.png" alt="WWWebsolutions logo" height="40" class="mr-2" />
				WWWebsolutions
			</b-navbar-brand>
		</b-navbar>

		<!-- Intro sectie -->
		<b-container class="mb-4">
			<b-jumbotron header="De ideale webshop voor elk bedrijf met een groot assortiment" lead="Een webshop met duizenden producten vereist een snelle, overzichtelijke en gebruiksvriendelijke website.">
				<p>
					Of u nu actief bent in de groothandel, retail of productie:
					klanten willen eenvoudig het juiste product kunnen vinden.
					WWWebsolutions ontwikkelt gebruiksvriendelijke webshops op maat.
				</p>
				<b-button variant="primary" href="#contact">Neem contact op</b-button>
			</b-jumbotron>
		</b-container>

		<!-- USP sectie -->
		<section class="usp-section mb-4 py-5">
			<b-container>
				<b-row>
					<!-- Linkerkolom -->
					<b-col md="6">
						<div class="usp-item">
							<div class="icon-circle"><b-icon icon="cursor" font-scale="1.5" /></div>
							<p>Klanten kunnen navigeren via productcategorieën of snel zoeken via producttegels met slimme filters.</p>
						</div>

						<div class="usp-item">
							<div class="icon-circle"><b-icon icon="people" font-scale="1.5" /></div>
							<p>Meerdere gebruikers van WWWebsolutions kunnen eenvoudig samenwerken of zelfs gezamenlijk inkopen.</p>
						</div>

						<div class="usp-item">
							<div class="icon-circle"><b-icon icon="funnel" font-scale="1.5" /></div>
							<p>Elk productkenmerk kan worden gebruikt als filter. Zo vinden klanten snel precies wat ze zoeken.</p>
						</div>

						<div class="usp-item">
							<div class="icon-circle"><b-icon icon="arrow-up-circle" font-scale="1.5" /></div>
							<p>Binnen enkele dagen is uw webshop live. Vraag ons naar de mogelijkheden.</p>
						</div>
					</b-col>

					<!-- Rechterkolom -->
					<b-col md="6">
						<div class="usp-item">
							<div class="icon-circle"><b-icon icon="search" font-scale="1.5" /></div>
							<p>Zoek op naam, trefwoord of artikelnummer. Met slimme suggesties in de zoekbalk navigeert de klant direct naar het juiste product.</p>
						</div>

						<div class="usp-item">
							<div class="icon-circle"><b-icon icon="box-seam" font-scale="1.5" /></div>
							<p>Kies uit een standaard basispakket (ca. 60.000 artikelen) of start met een lege webshop en voeg uw eigen producten en merken toe – al vanaf een verrassend laag tarief.</p>
						</div>

						<div class="usp-item">
							<div class="icon-circle"><b-icon icon="tags" font-scale="1.5" /></div>
							<p>Toon prijzen, verpakkingshoeveelheden, staffelkortingen en meer op een heldere manier.</p>
						</div>

						<div class="usp-item">
							<div class="icon-circle"><b-icon icon="star-fill" font-scale="1.5" /></div>
							<p>Klanten kunnen persoonlijke lijsten aanmaken, handig voor herhaalbestellingen of projectmatig inkopen.</p>
						</div>
					</b-col>
				</b-row>
			</b-container>
		</section>

		<!-- Voor wie sectie -->
		<b-container class="mb-4">
			<b-card>
				<h3>Voor wie?</h3>
				<p>
					Of u nu een bestaande webshop wilt vernieuwen of een compleet nieuwe online winkel wilt starten:
					met WWWebsolutions bent u verzekerd van een krachtige, toekomstbestendige oplossing.
				</p>
				<p><strong>De ideale webshop voor de technische groothandel</strong></p>
			</b-card>
		</b-container>

		<!-- Contact sectie -->
		<b-container id="contact" class="mb-4">
			<b-card>
				<h3>Meer informatie</h3>
				<p>
					Wilt u meer zien? Neem dan een kijkje op onze
					<b-link href="https://metavak.brabanttools.nl/">demowebshop</b-link> en ontdek de mogelijkheden.
				</p>
				<p>
					Voor meer informatie kunt u contact opnemen met
					<b-link href="tel:0613053051">06-13053051</b-link>
					of vul het <b-link href="#form">contactformulier</b-link> in.
				</p>
			</b-card>
		</b-container>

		<b-container id="form" class="mb-4">
			<b-card>
				<b-form @submit.prevent="sendMail()">
					<b-form-group horizontal
												:label-cols="4"
												label="Naam"
												label-for="name">
						<b-form-input id="name" v-model.trim="mail.name" placeholder="Uw naam"></b-form-input>
					</b-form-group>
					<b-form-group horizontal
												:label-cols="4"
												label="E-mail*"
												label-for="email">
						<b-form-input id="email" v-model.trim="mail.email" type="email" placeholder="Uw e-mailadres" required></b-form-input>
					</b-form-group>
					<b-form-group horizontal
												:label-cols="4"
												label="Tel."
												label-for="phone">
						<b-form-input id="phone" v-model.trim="mail.phone" placeholder="Uw telefoonnummer"></b-form-input>
					</b-form-group>
					<b-button type="submit" variant="primary">Ik wil meer informatie</b-button>
				</b-form>
			</b-card>
		</b-container>

		<!-- Footer -->
		<b-container>
			<b-footer class="text-center bg-light py-3">
				<small>&copy; 2025 WWWebsolutions</small>
			</b-footer>
		</b-container>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import * as types from '../store/mutation-types'

	export default {
		name: 'Home',
		data() {
			return {
				mail: { name: '', email: '', phone: '' }
			}
		},
		methods: {
			sendMail() {
				this.$store.commit(types.SET_MAIL_TO_SEND, this.mail)
				this.$store.dispatch('sendContactMail').then(() => {
					if (this.isMailSent) {
						this.$notify({ group: 'success', type: 'success', title: 'Succes', text: 'Email is verzonden! U hoort zo spoedig mogelijk van ons.' })
					}
				})
			}
		},
		computed: {
			...mapGetters({
				isMailSent: 'isMailSent'
			})
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap');

	* {
		font-family: 'Open Sans', Arial, sans-serif;
	}

	.usp-section {
		background-color: #e6f7fa; /* zachte lichtblauw */
	}

	.usp-item {
		display: flex;
		align-items: flex-start;
		margin-bottom: 1.5rem;
	}

		.usp-item p {
			margin: 0;
			font-size: 1rem;
			line-height: 1.5;
			color: #333;
		}

	/* Icon in cirkel */
	.icon-circle {
		min-width: 48px;
		min-height: 48px;
		border-radius: 50%;
		background: white;
		border: 2px solid #004aad;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 1rem;
		color: #004aad;
		flex-shrink: 0;
	}

	/* Titels */
	h3 {
		color: #004aad;
		font-weight: 600;
	}

	/* Responsief gedrag */
	@media (max-width: 767px) {
		.usp-item {
			flex-direction: column;
			align-items: center;
			text-align: center;
		}

			.usp-item .icon-circle {
				margin-right: 0;
				margin-bottom: 0.5rem;
			}
	}
</style>

